module.exports = __webpack_public_path__ + "img/overview-disabled.e17d3ebe.svg";